// src/context/CookieConsentContext.js
import React, { createContext, useState, useEffect } from 'react';

const CookieConsentContext = createContext();

export const CookieConsentProvider = ({ children }) => {
  const [cookieAccepted, setCookieAccepted] = useState(false);
  const COOKIE_EXPIRY_DAYS = 30;

  useEffect(() => {
    const consent = localStorage.getItem('cookieAccepted');
    const consentTimestamp = localStorage.getItem('cookieAcceptedTimestamp');
    if (consent && consentTimestamp) {
      const currentTime = new Date().getTime();
      const expiryTime = new Date(Number(consentTimestamp)).getTime() + COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000;

      if (currentTime < expiryTime) {
        setCookieAccepted(true);
      } else {
        localStorage.removeItem('cookieAccepted');
        localStorage.removeItem('cookieAcceptedTimestamp');
      }
    }
  }, []);

  const handleAcceptCookies = () => {
    const currentTime = new Date().getTime();
    localStorage.setItem('cookieAccepted', 'true');
    localStorage.setItem('cookieAcceptedTimestamp', currentTime.toString());
    setCookieAccepted(true);
  };

  const resetCookieConsent = () => {
    setCookieAccepted(false);
  };

  return (
    <CookieConsentContext.Provider value={{ cookieAccepted, handleAcceptCookies, resetCookieConsent }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => React.useContext(CookieConsentContext);
